export const STATUS_PENDING = 'Pending'
export const STATUS_IN_PROGRESS = 'In progress'
export const STATUS_BLOCKED = 'Blocked'
export const STATUS_COMPLETED = 'Completed'
export const STATUS_APPROVAL = 'Approval'

export const STATUSES = [STATUS_PENDING, STATUS_IN_PROGRESS, STATUS_APPROVAL, STATUS_COMPLETED, STATUS_BLOCKED]
export const STATUSES_VISIBLE_FOR_EMPLOYEE = [STATUS_IN_PROGRESS, STATUS_APPROVAL, STATUS_COMPLETED, STATUS_BLOCKED]